import { render, staticRenderFns } from "./MyQuizzesListView.vue?vue&type=template&id=2d454d6d&scoped=true&"
import script from "./MyQuizzesListView.vue?vue&type=script&lang=js&"
export * from "./MyQuizzesListView.vue?vue&type=script&lang=js&"
import style0 from "./MyQuizzesListView.vue?vue&type=style&index=0&id=2d454d6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d454d6d",
  null
  
)

export default component.exports